export default __webpack_public_path__ + "static/vertragsservice-header-image-db7189e0a3f37674774fb0e3949a0e4e.png";